<template>
  <v-form ref="form">
    <v-container ref="scrollContain" fluid class="overflow-y-auto" style="max-height: calc(100vh - 200px)">

      <v-row dense class="mb-2" style="border: solid 1px #e1e3e2; border-radius: 15px; padding: 15px;">
        <v-col cols="12">
          <h3 class="font-weight-bold">{{ $t('titles.family_historic') }}:</h3>
        </v-col>

        <v-col class="d-flex" cols="12" sm="4" md="2">
          <v-radio-group data-cy="radio-diabetes" :rules="formRules" v-model="antecedentesForm.donor_diabetes" row dense>
            <p class="mb-1" style="width: 100%">{{ $t('inputs.clinical_histories.donor_diabetes') }}<span class="required">*</span></p>
            <v-radio :label="$t('options.yes')" value="SIM" color="#086318"></v-radio>
            <v-radio :label="$t('options.not')" value="NÃO" color="#086318"></v-radio>
            <v-radio :label="$t('options.dont_know')" value="NÃO SABE INFORMAR" color="#086318"></v-radio>
          </v-radio-group>
        </v-col>

        <v-col class="d-flex" cols="12" sm="4" md="2">
          <v-radio-group data-cy="radio-diabetes-familiar" :rules="formRules" v-model="antecedentesForm.family_history_diabetes" @change="clearDependents('diabetes_relatives')" row dense>
            <p class="mb-1" style="width: 100%">{{ $t('inputs.clinical_histories.family_history_diabetes') }}<span class="required">*</span></p>
            <v-radio :label="$t('options.yes')" value="SIM" color="#086318"></v-radio>
            <v-radio :label="$t('options.not')" value="NÃO" color="#086318"></v-radio>
            <v-radio :label="$t('options.dont_know')" value="NÃO SABE INFORMAR" color="#086318"></v-radio>
          </v-radio-group>
        </v-col>

        <v-col class="d-flex" cols="12" sm="3" md="2" v-if="showDiabetesRelatives">
          <v-radio-group :rules="formRules" v-model="antecedentesForm.diabetes_relatives" row dense>
            <p class="mb-1" style="width: 100%">{{ $t('inputs.clinical_histories.diabetes_relatives') }}<span class="required">*</span></p>
            <v-radio label="Parente 1º grau" value="Parente 1º grau" color="#086318"></v-radio>
            <v-radio label="Parente 2º grau" value="Parente 2º grau" color="#086318"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>

      <v-row dense class="mb-2" style="border: solid 1px #e1e3e2; border-radius: 15px; padding: 15px;">
        <v-col cols="12">
          <h3 class="font-weight-bold">{{ $t('titles.diseases_and_clinical_conditions') }}</h3>
        </v-col>

        <v-col class="d-flex" cols="12" sm="4" md="2">
          <v-radio-group data-cy="radio-broncoaspiracao" :rules="formRules" row v-model="antecedentesForm.bronchoaspiration">
            <p style="width: 100%">{{ $t('inputs.clinical_histories.bronchoaspiration') }}<span class="required">*</span></p>
            <v-radio :label="$t('options.yes')" value="SIM" color="#086318"></v-radio>
            <v-radio :label="$t('options.not')" value="NÃO" color="#086318"></v-radio>
            <v-radio :label="$t('options.dont_know')" value="NÃO SABE INFORMAR" color="#086318"></v-radio>
          </v-radio-group>
        </v-col>

        <v-col class="d-flex" cols="12" sm="4" md="2">
          <v-radio-group data-cy="radio-dialise" :rules="formRules" row v-model="antecedentesForm.inpatient_dialysis">
            <p style="width: 100%">{{ $t('inputs.clinical_histories.inpatient_dialysis') }}<span class="required">*</span></p>
            <v-radio :label="$t('options.yes')" value="SIM" color="#086318"></v-radio>
            <v-radio :label="$t('options.not')" value="NÃO" color="#086318"></v-radio>
            <v-radio :label="$t('options.dont_know')" value="NÃO SABE INFORMAR" color="#086318"></v-radio>
          </v-radio-group>
        </v-col>

        <v-col class="d-flex" cols="12" sm="4" md="2">
          <v-radio-group data-cy="radio-dst" :rules="formRules" row v-model="antecedentesForm.dst">
            <p style="width: 100%">{{ $t('inputs.clinical_histories.dst') }}<span class="required">*</span></p>
            <v-radio :label="$t('options.yes')" value="SIM" color="#086318"></v-radio>
            <v-radio :label="$t('options.not')" value="NÃO" color="#086318"></v-radio>
            <v-radio :label="$t('options.dont_know')" value="NÃO SABE INFORMAR" color="#086318"></v-radio>
          </v-radio-group>
        </v-col>

        <v-col class="d-flex" cols="12" sm="4" md="2">
          <v-radio-group data-cy="radio-has" :rules="formRules" row v-model="antecedentesForm.has">
            <p style="width: 100%">{{ $t('inputs.clinical_histories.has') }}<span class="required">*</span></p>
            <v-radio :label="$t('options.yes')" value="SIM" color="#086318"></v-radio>
            <v-radio :label="$t('options.not')" value="NÃO" color="#086318"></v-radio>
            <v-radio :label="$t('options.dont_know')" value="NÃO SABE INFORMAR" color="#086318"></v-radio>
          </v-radio-group>
        </v-col>

        <v-col class="d-flex" cols="12" sm="4" md="2">
          <v-radio-group data-cy="radio-asma" :rules="formRules" row v-model="antecedentesForm.asthma">
            <p style="width: 100%">{{ $t('inputs.clinical_histories.asthma') }}<span class="required">*</span></p>
            <v-radio :label="$t('options.yes')" value="SIM" color="#086318"></v-radio>
            <v-radio :label="$t('options.not')" value="NÃO" color="#086318"></v-radio>
            <v-radio :label="$t('options.dont_know')" value="NÃO SABE INFORMAR" color="#086318"></v-radio>
          </v-radio-group>
        </v-col>

        <v-col class="d-flex" cols="12" sm="4" md="2">
          <v-radio-group data-cy="radio-dpoc" :rules="formRules" row v-model="antecedentesForm.dpoc">
            <p style="width: 100%">{{ $t('inputs.clinical_histories.dpoc') }}<span class="required">*</span></p>
            <v-radio :label="$t('options.yes')" value="SIM" color="#086318"></v-radio>
            <v-radio :label="$t('options.not')" value="NÃO" color="#086318"></v-radio>
            <v-radio :label="$t('options.dont_know')" value="NÃO SABE INFORMAR" color="#086318"></v-radio>
          </v-radio-group>
        </v-col>

        <v-col class="d-flex" cols="12" sm="4" md="2">
          <v-radio-group data-cy="radio-trauma" :rules="formRules" row v-model="antecedentesForm.facial_trauma">
            <p style="width: 100%">{{ $t('inputs.clinical_histories.facial_trauma') }}<span class="required">*</span></p>
            <v-radio :label="$t('options.yes')" value="SIM" color="#086318"></v-radio>
            <v-radio :label="$t('options.not')" value="NÃO" color="#086318"></v-radio>
            <v-radio :label="$t('options.dont_know')" value="NÃO SABE INFORMAR" color="#086318"></v-radio>
          </v-radio-group>
        </v-col>

        <v-col class="d-flex flex-column" cols="12" sm="4" md="2">
          <v-radio-group data-cy="radio-cirurgia" :rules="formRules" row v-model="antecedentesForm.previous_surgery" @change="clearDependents('which_surgery')">
            <p style="width: 100%">{{ $t('inputs.clinical_histories.previous_surgery') }}<span class="required">*</span></p>
            <v-radio :label="$t('options.yes')" value="SIM" color="#086318"></v-radio>
            <v-radio :label="$t('options.not')" value="NÃO" color="#086318"></v-radio>
            <v-radio :label="$t('options.dont_know')" value="NÃO SABE INFORMAR" color="#086318"></v-radio>
          </v-radio-group>
          <v-text-field
            v-if="showWhichSurgery"
            :rules="formRules"
            color="#086318"
            label="Qual?*"
            dense
            v-model="antecedentesForm.which_surgery"
          ></v-text-field>
        </v-col>

        <v-col class="d-flex flex-column" cols="12" sm="4" md="2">
          <v-radio-group data-cy="radio-cardiopatia" :rules="formRules" row v-model="antecedentesForm.heart_disease" @change="clearDependents('which_heart_disease')">
            <p style="width: 100%">{{ $t('inputs.clinical_histories.heart_disease') }}<span class="required">*</span></p>
            <v-radio :label="$t('options.yes')" value="SIM" color="#086318"></v-radio>
            <v-radio :label="$t('options.not')" value="NÃO" color="#086318"></v-radio>
            <v-radio :label="$t('options.dont_know')" value="NÃO SABE INFORMAR" color="#086318"></v-radio>
          </v-radio-group>
          <v-text-field
            v-if="showWhichHeartDisease"
            :rules="formRules"
            color="#086318"
            label="Qual?*"
            dense
            v-model="antecedentesForm.which_heart_disease"
          ></v-text-field>
        </v-col>

        <v-col class="d-flex flex-column" cols="12" sm="4" md="2">
          <v-radio-group data-cy="radio-contagiosa" :rules="formRules" row v-model="antecedentesForm.infectious_disease" @change="clearDependents('which_infectious')">
            <p style="width: 100%">{{ $t('inputs.clinical_histories.infectious_disease') }}<span class="required">*</span></p>
            <v-radio :label="$t('options.yes')" value="SIM" color="#086318"></v-radio>
            <v-radio :label="$t('options.not')" value="NÃO" color="#086318"></v-radio>
            <v-radio :label="$t('options.dont_know')" value="NÃO SABE INFORMAR" color="#086318"></v-radio>
          </v-radio-group>
          <v-text-field
            v-if="showWhichInfectious"
            :rules="formRules"
            color="#086318"
            label="Qual?*"
            dense
            v-model="antecedentesForm.which_infectious"
          ></v-text-field>
        </v-col>

        <v-col class="d-flex flex-column" cols="12" sm="4" md="2">
          <v-radio-group data-cy="radio-cirurgia-cornea" :rules="formRules" row v-model="antecedentesForm.corneal_surgery">
            <p style="width: 100%">{{ $t('inputs.clinical_histories.corneal_surgery') }}<span class="required">*</span></p>
            <v-radio :label="$t('options.yes')" value="SIM" color="#086318"></v-radio>
            <v-radio :label="$t('options.not')" value="NÃO" color="#086318"></v-radio>
            <v-radio :label="$t('options.dont_know')" value="NÃO SABE INFORMAR" color="#086318"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>

      <v-row dense class="mb-2" style="border: solid 1px #e1e3e2; border-radius: 15px; padding: 15px;">
        <v-col cols="12">
          <h3 class="font-weight-bold">{{ $t('titles.habits') }}:</h3>
        </v-col>

        <v-col class="d-flex" cols="12" sm="4" md="2">
          <v-radio-group data-cy="radio-piercing" :rules="formRules" row v-model="antecedentesForm.piercing">
            <p style="width: 100%">{{ $t('inputs.clinical_histories.piercing') }}<span class="required">*</span></p>
            <v-radio :label="$t('options.yes')" value="SIM" color="#086318"></v-radio>
            <v-radio :label="$t('options.not')" value="NÃO" color="#086318"></v-radio>
            <v-radio :label="$t('options.dont_know')" value="NÃO SABE INFORMAR" color="#086318"></v-radio>
          </v-radio-group>
        </v-col>

        <v-col class="d-flex flex-column" cols="12" sm="4" md="2">
          <v-radio-group data-cy="radio-tabagista" :rules="formRules" row v-model="antecedentesForm.smoker" @change="clearDependents('how_long')">
            <p style="width: 100%">{{ $t('inputs.clinical_histories.smoker') }}<span class="required">*</span></p>
            <v-radio :label="$t('options.yes')" value="SIM" color="#086318"></v-radio>
            <v-radio :label="$t('options.not')" value="NÃO" color="#086318"></v-radio>
            <v-radio :label="$t('options.dont_know')" value="NÃO SABE INFORMAR" color="#086318"></v-radio>
          </v-radio-group>
          <v-text-field
            v-if="showSmokerDuration"
            :rules="formRules"
            color="#086318"
            label="Há quanto tempo?*"
            dense
            v-model="antecedentesForm.how_long"
          ></v-text-field>
        </v-col>

        <v-col class="d-flex flex-column" cols="12" sm="4" md="2">
          <v-radio-group data-cy="radio-tatuagem" :rules="formRules" row v-model="antecedentesForm.tattoo" @change="clearDependents('tattoo_time')">
            <p style="width: 100%">{{ $t('inputs.clinical_histories.tattoo') }}<span class="required">*</span></p>
            <v-radio :label="$t('options.yes')" value="SIM" color="#086318"></v-radio>
            <v-radio :label="$t('options.not')" value="NÃO" color="#086318"></v-radio>
            <v-radio :label="$t('options.dont_know')" value="NÃO SABE INFORMAR" color="#086318"></v-radio>
          </v-radio-group>
          <v-text-field
            v-if="showTattooTime"
            :rules="formRules"
            color="#086318"
            label="Tempo:*"
            dense
            v-model="antecedentesForm.tattoo_time"
          ></v-text-field>
        </v-col>

        <v-col class="d-flex flex-column" cols="12" sm="4" md="2">
          <v-radio-group data-cy="radio-drogas" :rules="formRules" row v-model="antecedentesForm.illicit_drugs" @change="clearDependents('injectable_drugs', 'injecting_drugs', 'non_injecting_drugs')">
            <p style="width: 100%">{{ $t('inputs.clinical_histories.illicit_drugs') }}<span class="required">*</span></p>
            <v-radio :label="$t('options.yes')" value="SIM" color="#086318"></v-radio>
            <v-radio :label="$t('options.not')" value="NÃO" color="#086318"></v-radio>
            <v-radio :label="$t('options.dont_know')" value="NÃO SABE INFORMAR" color="#086318"></v-radio>
          </v-radio-group>
        </v-col>

        <v-col class="d-flex flex-column" cols="12" sm="2" v-if="showInjectableDrugs">
          <v-radio-group data-cy="radio-injetaveis" :rules="formRules" row v-model="antecedentesForm.injectable_drugs" @change="clearDependents('injecting_drugs', 'non_injecting_drugs')">
            <p style="width: 100%">{{ $t('inputs.clinical_histories.injectable_drugs') }}<span class="required">*</span></p>
            <v-radio :label="$t('options.yes')" value="SIM" color="#086318"></v-radio>
            <v-radio :label="$t('options.not')" value="NÃO" color="#086318"></v-radio>
          </v-radio-group>
          <v-text-field
            v-if="showInjectingDrugs"
            :rules="formRules"
            color="#086318"
            label="Quais?*"
            dense
            v-model="antecedentesForm.injecting_drugs"
          ></v-text-field>
        </v-col>

        <v-col
          class="d-flex"
          cols="12"
          sm="4"
          md="3"
          v-if="showNonInjectingDrugs"
        >
          <v-textarea
            :rules="formRules"
            color="#086318"
            label="Quais não injetáveis?*"
            row-height="12"
            rows="4"
            outlined
            dense
            v-model="antecedentesForm.non_injecting_drugs"
          ></v-textarea>
        </v-col>

        <v-col class="d-flex flex-column" cols="12" sm="12" md="3">
          <v-radio-group data-cy="radio-alcoolista" :rules="formRules" row v-model="antecedentesForm.alcoholic" @change="clearDependents('type_of_alcoholic', 'time_of_alcoholic', 'frequency_of_alcoholic')">
            <p style="width: 100%">{{ $t('inputs.clinical_histories.alcoholic') }}<span class="required">*</span></p>
            <v-radio :label="$t('options.yes')" value="SIM" color="#086318"></v-radio>
            <v-radio :label="$t('options.not')" value="NÃO" color="#086318"></v-radio>
            <v-radio :label="$t('options.dont_know')" value="NÃO SABE INFORMAR" color="#086318"></v-radio>
          </v-radio-group>
        </v-col>

        <v-col class="d-flex" cols="12" sm="2" v-if="showAlcoholicDetails">
          <v-text-field :rules="formRules" color="#086318" label="Tipo:*" dense v-model="antecedentesForm.type_of_alcoholic"></v-text-field>
        </v-col>

        <v-col class="d-flex" cols="12" sm="2" v-if="showAlcoholicDetails">
          <v-text-field :rules="formRules" color="#086318" label="Tempo:*" dense v-model="antecedentesForm.time_of_alcoholic"></v-text-field>
        </v-col>

        <v-col class="d-flex" cols="12" sm="2" v-if="showAlcoholicDetails">
          <v-text-field :rules="formRules" color="#086318" label="Frequência:*" dense v-model="antecedentesForm.frequency_of_alcoholic"></v-text-field>
        </v-col>
      </v-row>

      <v-row class="buttons-container">
        <div class="buttons">
          <v-row class="buttons-row">
            <v-btn
            data-cy="btn-save-antecedentes"
              class="rounded-lg buttons-action" 
              elevation="0"
              color="#41916b"
              :loading="loadingBTN"
              @click="createDoadorReports()"
            >
              <span class="textBtn text-white">{{$t('buttons.save_and_continue')}}</span>
            </v-btn>

            <v-btn
              class="rounded-lg buttons-action" 
              elevation="0"
              color="grey"
              @click="clearFields()"
            >
              <span class="textBtn text-white">{{$t('buttons.clean_up')}}</span>
            </v-btn>

            <v-btn
              class="rounded-lg buttons-action" 
              elevation="0"
              color="grey"
              @click="$emit('changeTab', 0)"
            >
              <span class="textBtn text-white">{{$t('buttons.return')}}</span>
            </v-btn>
          </v-row>
        </div>
      </v-row> 
    </v-container>
  </v-form>
</template>

<script>
import axios from "@/axios";
import { mapGetters, mapActions } from "vuex";
import currentUser from "@/utils/currentUser";
export default {
  data() {
    return {
      formRules: [(v) => !!v || "Este campo é obrigatório"],
      antecedentesForm: {}, 
      loadingBTN: false,
    };
  },

  created() {
    this.matchDonor();
  },

  mounted() {
    this.scrollToTop();
  },

  computed: {
    ...mapGetters({
      resource: "getPatientData",
      donor_id: "getDonorId",
      me_clinical_histories: "getMEClinicalHistories",
    }),

    userData() {
      return currentUser.getUserData();
    },

    donorID() {
      return this.donor_id ? this.donor_id : this.resource.id;
    },

    showDiabetesRelatives() {
      return this.antecedentesForm.family_history_diabetes == 'SIM';
    },
    
    showWhichSurgery() {
      return this.antecedentesForm.previous_surgery == 'SIM';
    },

    showWhichHeartDisease() {
      return this.antecedentesForm.heart_disease == 'SIM';
    },

    showWhichInfectious() {
      return this.antecedentesForm.infectious_disease == 'SIM';
    },

    showSmokerDuration() {
      return this.antecedentesForm.smoker == 'SIM';
    },

    showTattooTime() {
      return this.antecedentesForm.tattoo == 'SIM';
    },

    showInjectableDrugs() {
      return this.antecedentesForm.illicit_drugs == 'SIM';
    },

    showInjectingDrugs() {
      return this.antecedentesForm.injectable_drugs == 'SIM' && this.antecedentesForm.illicit_drugs === 'SIM';
    },

    showNonInjectingDrugs() {
      return this.antecedentesForm.injectable_drugs == 'NÃO' && this.antecedentesForm.illicit_drugs === 'SIM';
    },

    showAlcoholicDetails() {
      return this.antecedentesForm.alcoholic == 'SIM';
    },
  },

  methods: {
    ...mapActions(["changePatientData", "changeSnackBarData"]),

    clearDependents(...fields) {
      fields.forEach((field) => this.$set(this.antecedentesForm, field, undefined));
    },

    matchDonor() {
      if (this.me_clinical_histories && this.donorID == this.me_clinical_histories.donor_id) {
        this.antecedentesForm = this.me_clinical_histories;
      }
    },

    scrollToTop() {
      this.$refs.scrollContain.scrollTop = 0;
    },

    async createDoadorReports() {
      if (!this.$refs.form.validate()) {
        this.changeSnackBarData({
          status: true,
          type: "erro",
          titleMessage: "Campos obrigatórios!",
          bodyMessage: "Por favor, revise os campos destacados",
          cardColor: "red",
          titleIcon: "mdi-close-circle",
        });

        setTimeout(() => {
          this.closeSnackBar();
          this.loadingBTN = false;
        }, 5000);
        return;
      }

      const newStatus = this.resource.donor_status_slug;

      this.loadingBTN = true;
 
      try {
        const data = { ...this.antecedentesForm };
        data.donor_id = this.donorID;
        data.user_id = this.userData.id;

        const response = data.id
          ? await axios.put(`/clinical_histories/${data.id}`, data)
          : await axios.post(`/clinical_histories`, data);

        if (!data.id && response && response.data && response.data.id) {
          data.id = response.data.id;
        }

        this.changeSnackBarData({
          status: true,
          type: "success",
          titleMessage: response.data.message,
          bodyMessage: "",
          cardColor: "success",
          titleIcon: "mdi-check-circle",
        });

        setTimeout(() => {
          this.loadingBTN = false;
          this.closeSnackBar();

          this.resource.id = this.donorID;
          this.changePatientData({ ...this.resource });

          this.redirect(newStatus);
        }, 3000);
      } catch (error) { 
        this.changeSnackBarData({
          status: true,
          type: "erro",
          titleMessage: "Algo deu errado!",
          bodyMessage: (error && error.details) || "",
          cardColor: "red",
          titleIcon: "mdi-close-circle",
        });

        setTimeout(() => {
          this.loadingBTN = false;
          this.closeSnackBar(); 
        }, 4000);
      } 
    },

    redirect(status) {
      switch (status) {
        case "aguard-aval-med":
          this.$router.push("/validacao-doador-me");
          break;
        case "aguard-aut-familiar":
          this.$router.push("/aceite-familiar");
          break;
        default:
          this.$router.push("/pacientes");
      }
    },

    clearFields(){
      this.$refs.form.reset()
      this.$refs.form.resetValidation()
    },

    closeSnackBar() {
      this.changeSnackBarData({
        status: false,
        type: "",
        titleMessage: "",
        bodyMessage: "",
        cardColor: "",
        titleIcon: "",
      });
    },
  },
};
</script>

<style scoped>
.required {
  color: red;
  font-size: 1.2em;
}

.buttons {
  margin-top: 16px;
}

.buttons-container {
  display: flex;
  justify-content: center;
}

.buttons-row {
  display: flex;
  justify-content: center;
  align-items: center;
}

.buttons-action {
  margin-right: 7px;
}

.buttons-action:last-child {
  margin-right: 0;
}

.textBtn {
  color: #fff;
}

@media (max-width: 768px) {
  .buttons {
    width: 100%;
  }

  .buttons-row {
    flex-direction: column;
    align-items: stretch;
  }

  .buttons-action {
    width: 100%;
    margin-right: 0;
    margin-bottom: 8px;
  }

  .buttons-action:last-child {
    margin-bottom: 0;
  }
}
</style>
